<template>
  <div style="height: 100%;">
    <div class="searchHeader">
      <div style="position: relative;margin-bottom: 30px;">
        <i class="el-icon-s-fold" @click="backHome"></i>
        <img class="stepsigrinerLogo" src="../../../public/img/ynbf.jpg" alt="" srcset="">
      </div>
      <el-input size="default" placeholder="Serial number/Model" v-model="serialNo">
        <el-button slot="append" icon="el-icon-search" @click="searchHandle"></el-button>
      </el-input>
    </div>

    <div v-loading.fullscreen.lock="loading">
      <div class="stepsigrinerMain" v-if="info">
        <img style="width: 200px;" src="../../../public/img/ynbf2.png" alt="" srcset="">
        <div class="productName">STEP- SIGRINER CONTROL PANEL</div>
        <ul>
          <li>CONTRACT NO：{{ info.projectName }}</li>
          <li>MODEL：SSCP-GE9000</li>
          <li>SIZE：1000*650*260</li>
          <li>SERIAL NO.：{{ info.serialNo }}</li>
          <li>POWER：{{ info.power }}</li>
          <li>INPUT：{{ info.input }}</li>
          <li>OUTPUT：{{ info.output }}</li>
          <li>MOTOR TYPE：GEARED/GEARLESS</li>
          <li>LIFT SPEED：0.4~2.5M/S</li>
          <li>MOTOR BRAKE ：48~207 VDC</li>
          <li>ENCODER SUPPLY：5V/12V</li>
          <li>ENCODER TYPE ：ABZ/1387/1313</li>
          <li>MAXIMUM STOP：64 STOP</li>
          <li>ARD FUNCTION：BUILT IN</li>
          <li>CONTROL METHOD：SINGLEX/DUPLEX/GROUP CONTROI</li>
          <li>WIRING CONNECTION：MODULARIZED CONNECTING BOARD</li>
          <li>INSTALLATION：INSIDE THE WALL/ON FLOOR</li>
          <li>ENVIRONMENTAL TEMPERATURE ：-10~45℃</li>
          <li>MANUFACTURING DATE ：{{ info.year }}</li>
          <li>MADE IN GERMANY</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serialNo: "",
      info: null,
      loading: false
    };
  },

  created() {
    window.history.pushState(null, null, window.location.href);
  },

  methods: {

    backHome() {
      window.history.back();
    },

    searchHandle() {
      if (!this.serialNo) {
        this.$message({
          message: 'Please enter the serial number.',
          type: 'warning'
        });
        return;
      }
      this.loading = true;
      this.$http.get("basic", `sd/so/selectOrderSIGRINER?serialNo=${this.serialNo}`).then(res => {
        this.loading = false;
        if (res.data) {
          this.info = res.data;
        } else {
          this.$message({
            message: 'Please check whether the serial number is incorrect.',
            type: 'warning'
          });
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.searchHeader {
  font-size: 30px;
  padding: 10px 15px;
  color: #909399;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;

  .stepsigrinerLogo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
  }
}

.stepsigrinerMain {
  padding: 150px 15px 15px 15px;
  height: 100%;

  .productName {
    font-size: 18px;
  }

  ul {
    padding: 0 15px;

    li {
      line-height: 30px;
      font-size: 14px;
    }
  }
}
</style>